"use client"

import { MemberListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { generateResponsiveCSS } from "../../../lib/helper"
import { MemberListGrid } from "./components/MemberListGrid"
import { MemberListTitle } from "./components/MemberListTitle"

export const RenderConfig: ComponentConfig<MemberListProps> = {
  render: ({ title, description, members, styles, responsiveType, className }) => {
    const id = `member-list-${Math.random().toString(36).substr(2, 9)}`
    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <div
          id={id}
          className={twMerge(
            "container mx-auto max-w-[1200px] pt-[8.5rem] pb-[7.3125rem] sm:pt-[6.25rem] sm:pb-[4.8125rem]",
            id,
            className,
          )}
        >
          {/* Title and Description */}
          <MemberListTitle title={title} description={description} />

          {/* Members Grid */}
          <MemberListGrid members={members || []} />
        </div>
      </>
    )
  },
}
